/**
 * 物件種別に応じた詳細条件フィールドの表示制御（bukken_list / 検索ページの SearchAddOptions で共通）
 */
export const PROPERTY_TYPE_FIELD_VISIBILITY = {
	new: ['buildingArea', 'landArea', 'layout', 'age', 'walk'],
	used: ['buildingArea', 'landArea', 'layout', 'age', 'walk'],
	land: ['landArea', 'walk'],
	mansion: ['exclusiveArea', 'layout', 'age', 'walk'],
};

/**
 * @param {string} selectedType - new | used | land | mansion
 * @param {Element[]} fieldElements - data-bukken-filter-field を持つ要素
 */
export function updatePropertyTypeFilterFields(selectedType, fieldElements) {
	const visibleFields = PROPERTY_TYPE_FIELD_VISIBILITY[selectedType] ?? [];
	const isSp =
		typeof window !== 'undefined' &&
		typeof window.matchMedia === 'function' &&
		window.matchMedia('(max-width: 767px)').matches;

	fieldElements.forEach((element) => {
		if (isSp && element.closest('.bukkenList__side')) {
			return;
		}
		const fieldName = element.dataset.bukkenFilterField;
		const shouldShow = visibleFields.includes(fieldName);
		element.hidden = !shouldShow;

		element.querySelectorAll('input, select, textarea, button').forEach((control) => {
			control.disabled = !shouldShow;
		});
	});
}
